import {SET_GOLOBAL_LANGUAGE} from './type.action';

export const setGlobalLanguage = (language) => {
  localStorage.setItem('i18nLanguage',language)
  return { type: SET_GOLOBAL_LANGUAGE, payload: language };
};

